import { render, staticRenderFns } from "./BannerUpsertForm.vue?vue&type=template&id=2fd0fd43"
import script from "./BannerUpsertForm.vue?vue&type=script&lang=js"
export * from "./BannerUpsertForm.vue?vue&type=script&lang=js"
import style0 from "./BannerUpsertForm.vue?vue&type=style&index=0&id=2fd0fd43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports